import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";
import pickBy from "lodash/pickBy";

export default {
  getCategories() {
    return apiService.get(endpoints.wizard.company.categories);
  },

  postCompany(form) {
    return apiService.post(endpoints.wizard.company.profile, form);
  },

  getCompanies() {
    return apiService.get(endpoints.wizard.company.profile);
  },
  getCompanyParent(id) {
    return apiService.get(endpoints.companyParent(id));
  },
  getCompanyDetails(id) {
    return apiService.get(endpoints.companyDetails(id));
  },
  getCompany() {
    return apiService.get(endpoints.wizard.company.profile);
  },

  updateCompany(form, id) {
    return apiService.put(`${endpoints.wizard.company.profile}${id}/`, form);
  },

  getAutocompleteList(query, params = {}) {
    const mergedParams = {
      q: query,
      ...params
    };
    return apiService.get(endpoints.wizard.businessAddresses.autocomplete, {
      params: pickBy(mergedParams)
    });
  },

  getBusinessAddressData(id) {
    return apiService.get(
      `${endpoints.wizard.businessAddresses.autocomplete}${id}/`
    );
  },

  patchCompanyData(data, id) {
    return apiService.patch(`${endpoints.wizard.company.profile}${id}/`, data);
  },

  getLastFacebookAudit(companyId) {
    return apiService.get(
      `${endpoints.competition.default}${companyId}/facebook-audits/last/`
    );
  },

  getFacebookAuditsHistory(companyId, { from, to }, type) {
    return apiService.get(
      `${endpoints.competition.default}${companyId}/facebook-audits/?created_at__gte=${from}&created_at__lt=${to}&fields=created_at,${type}`
    );
  },

  getLastInstagramAudit(companyId) {
    return apiService.get(
      `${endpoints.competition.default}${companyId}/instagram-audits/last/`
    );
  },

  getInstagramAuditsHistory(companyId, { from, to }, type) {
    return apiService.get(
      `${endpoints.competition.default}${companyId}/instagram-audits/?created_at__gte=${from}&created_at__lt=${to}&fields=created_at,${type}`
    );
  },

  getGus(taxNumber) {
    return apiService.get(`${endpoints.wizard.gus}?nip=${taxNumber}`);
  },

  getCompanySubscriptions() {
    return apiService.get(endpoints.companySubscriptions);
  },

  getSubscriptionBillingPreview() {
    return apiService.get(endpoints.subscriptionBillingPreview);
  },

  getEnterpriseInvitation() {
    return apiService.get(endpoints.enterpriseInvitation);
  }
};
